import React from "react";
import { Box } from "@mui/material";
import campagne from "../assets/img/campagne.png";

const Footer: React.FC = () => {
    return (
        <Box
            component="footer"
            sx={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Box
                component="img"
                src={campagne}
                alt="Illustration de paysage de campagne"
                sx={{
                    width: {
                        xs: "100%", // 📱 mobile
                        sm: "80%",  // optionnel : tablette
                        md: "50%",  // 💻 desktop
                    },
                    height: "auto",
                    display: "block",
                    opacity: 0.7,
                    margin: "0 auto",
                }}
            />
        </Box>
    );
};

export default Footer;
